export enum MessageStatus {
    Created = 'created',
    Delivered = 'delivered',
    HasBeenRead = 'has_been_read',
}
